module.exports = __webpack_public_path__ + "img/76163.00457bb6.svg";